<template>
  <main-body>
    <div class="main-con">
      <table class="data-table" style="table-layout: fixed">
        <thead style="z-index: 1">
        <tr >
          <th>스탭 명</th>
          <th class="width-pixel-200">
            시작시간
          </th>
          <th class="width-pixel-200">
            종료 시간
          </th>
          <th class="width-pixel-120">
            ! 롤백 카운트
          </th>
          <th class="width-pixel-120">
            커밋 카운트
          </th>
          <th class="width-pixel-120">
            읽기 카운트
          </th>
          <th class="width-pixel-120">
            쓰기 카운트
          </th>
          <th class="width-pixel-120">
            filterCount
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in items" :key="index" >
          <template>
            <td>{{ item.stepName }}</td>
            <td>{{ item.startTime }}</td>
            <td>{{ item.endTime }}</td>
            <td class="table-text-right">
              {{ numberFormat(item.rollbackCount) }}
            </td>
            <td class="table-text-right">
              {{ numberFormat(item.commitCount) }}
            </td>
            <td class="table-text-right">
              {{ numberFormat(item.readCount) }}
            </td>
            <td class="table-text-right">
              {{ numberFormat(item.writeCount) }}
            </td>
            <td class="table-text-right">
              {{ numberFormat(item.filterCount) }}
            </td>
          </template>
        </tr>
        </tbody>
      </table>
    </div>
  </main-body>
</template>


<script>
import {PATH} from "@/constants";
import MainBody from "@/components/common/layout/MainBody.vue";

export default {
  name: "BatchCheckCompleteComp",
  components: {
    MainBody,
  },
  props: {
    searchOptions: {
      type: Object
    },
    identifier: {
      type: Number
    }

  },
  data() {
    return {
      items: [],
      dialog: false,
      page: 1,
      isSummaryLoading: false,
      sortOption: {
        sortBy: [],
        sortDesc: [],
      },
    }
  },

  watch: {
    identifier() {
      this.onLoad()
    },
  },

  mounted() {
    this.onLoad()
  },

  methods: {
    numberFormat(number) {
      if (!number) return '0'
      return Number(number).toLocaleString()
    },

    onLoad() {
      this.items.splice(0, this.items.length)
      this.loadData()
    },
    loadData() {
      this.isLoading = true
      this.$request(PATH.BATCH.CHECK)
          .setObject({...this.searchOptions, ...this.sortOption})
          .catch(e => {
            this.isLoading = false;
            alert("조회 실패")
          })
          .enqueue()
          .then(res => {
            this.items.push(...res.data)
            this.dataTotalCount = res.dataTotalCount
            this.isLoading = false;
          });
    },

  },
}
</script>

<style scoped>
.main-con {
  position: relative;
  width: 100%;
  height: 95%;
  overflow-y: scroll;
}

.main-con .data-table {
  position: relative;
  width: 100%;
  border-spacing: 0;
}

.main-con .data-table thead {
  position: sticky;
  top: 0;
  background: #ddd;
}

.main-con .data-table thead tr th {
  font-size: 13px;
}

.main-con .data-table tbody td {
  padding: 0.15rem;
  text-align: left;
  border: 1px solid #ccc;
  font-size: 13px;
}

.main-con .data-table tbody tr:nth-child(even) {
  background: #f5f5f5;
}

.main-con .data-table tbody tr:hover {
  background: #ddd;
}

.infinity_scroll_table_paging {
  margin-top: 10px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
</style>
